<ng-template
  #expandable
  let-id="id"
  let-columnId="columnId"
  let-all="all"
  let-allLength="allLength"
  let-short="short"
  let-shortLength="shortLength"
  let-template="template"
  let-expandLabel="expandLabel"
  let-collapseLabel="collapseLabel"
  let-group="group"
  let-row="row"
>
  @if (shortLength > 0) {
    <ng-container
      [ngTemplateOutlet]="template"
      [ngTemplateOutletContext]="{
        $implicit: expandedListItems[columnId][id] ? all : short,
        row,
      }"
    ></ng-container>
    @if (allLength > shortLength) {
      <rt-button
        variant="outline"
        margin-tb-small
        (click)="
          $event.stopPropagation();
          expandedListItems[columnId][id] ? collapseList(group, id) : expandList(group, id)
        "
      >
        <rt-truncate>
          @if (expandedListItems[columnId][id]) {
            {{ collapseLabel }}
          }
          @if (!expandedListItems[columnId][id]) {
            {{ expandLabel }}
          }
        </rt-truncate>
      </rt-button>
    }
  }
  @if (shortLength === 0) {
    <ng-container [ngTemplateOutlet]="empty" />
  }
</ng-template>

<ng-template #locationPlaceholders let-locationPlaceholders="locationPlaceholders">
  @if (locationPlaceholders) {
    @for (
      placeholder of locationPlaceholders;
      track trackByLocation($index, placeholder);
      let first = $first;
      let last = $last
    ) {
      @if (placeholder && !first) {
        <div class="empty_div"></div>
      }
    }
  }
</ng-template>

<ng-template #name let-candidate="row" [ngTemplateType]="CellContext">
  <div class="candidate-cell" layout-horizontal layout-align-items-center>
    @if (candidate.isAnonymous) {
      <rt-avatar
        [hasUnreadNotifications]="candidate.unreadNotifications"
        [tooltipTplRef]="avatarTooltipTplRef"
        [shape]="'oval'"
        size="small"
        type="icon"
        iconName="visibility-off"
        customIconBackgroundColor="colorAvatarSteelLighter"
        customIconColor="colorIconDisabled"
        margin-right-small
      ></rt-avatar>
    } @else {
      <rt-avatar
        [hasUnreadNotifications]="candidate.unreadNotifications"
        [type]="candidate.hasAvatar ? 'image' : 'initials'"
        [size]="'small'"
        [shape]="'oval'"
        [imageSrc]="candidate.photoThumbUrl"
        [initials]="candidate.initials"
        [tooltipTplRef]="avatarTooltipTplRef"
        margin-right-small
      >
      </rt-avatar>
    }

    <ng-template #avatarTooltipTplRef>
      <div
        layout-full-height
        layout-full-width
        [rtTooltip]="'app.common.unread_notification' | translate"
      ></div>
    </ng-template>
    <div>
      <div class="candidate-cell__profile" layout-align-items-center>
        @if (isLinkWithHref) {
          <a
            class="candidate-link"
            (click)="allowOpenInNewWindow($event)"
            [routerLink]="['.']"
            [queryParams]="{ candidate: candidate.id }"
            queryParamsHandling="merge"
          >
            <rt-truncate>
              @if (candidate.highlight && candidate.highlight.name) {
                <span [innerHtml]="candidate.highlight.name[0]" text-weight-semi-bold> </span>
              }
              @if (!(candidate.highlight && candidate.highlight.name)) {
                <span text-weight-semi-bold>
                  {{ candidate.name }}
                </span>
              }
            </rt-truncate>
            @if (candidate.new) {
              <rt-badge color="primary" [text]="'app.common.new' | translate" margin-left-small>
              </rt-badge>
            }
          </a>
        } @else {
          <a class="candidate-link" (click)="openCandidateDialog(candidate.id)">
            <rt-truncate>
              @if (candidate.highlight && candidate.highlight.name) {
                <span [innerHtml]="candidate.highlight.name[0]" text-weight-semi-bold> </span>
              }
              @if (!(candidate.highlight && candidate.highlight.name)) {
                <span text-weight-semi-bold>
                  {{ candidate.name }}
                </span>
              }
            </rt-truncate>
            @if (candidate.new) {
              <rt-badge color="primary" [text]="'app.common.new' | translate" margin-left-small>
              </rt-badge>
            }
          </a>
        }
      </div>

      @if (candidate.formattedHighlights.length > 0) {
        <div class="candidate-cell__highlights">
          @for (
            highlight of candidate.formattedHighlights;
            track trackByHighlight($index, highlight)
          ) {
            @if (highlight.detailsInTooltip) {
              <ng-template #highlightTooltipTpl>
                @for (
                  highlight of highlight.allMatches;
                  track trackByValue($index, highlight);
                  let isLast = $last
                ) {
                  <div>
                    <p [innerHtml]="transformHighlightEmTags(highlight)"></p>
                    @if (!isLast) {
                      <rt-divider [style.opacity]="0.2" margin-tb-small-x></rt-divider>
                    }
                  </div>
                }
              </ng-template>

              <span
                rtTooltip
                [rtTooltipPosition]="'right'"
                [rtTooltipTemplate]="highlightTooltipTpl"
                class="highlight-item has-tooltip"
              >
                {{ highlight.label }}
                <br />
              </span>
            } @else {
              <p class="highlight-item">
                {{ highlight.label }}
                <span [innerHtml]="highlight.match"></span>
                @if (
                  highlight.additionalMatches.length > 0 &&
                  !hasHighlightExtended(candidate.id, highlight.key)
                ) {
                  <a
                    (click)="
                      $event.stopPropagation(); toggleExtendHighlight(candidate.id, highlight.key)
                    "
                  >
                    {{
                      'app.search.highlight.and_x_additional_matches'
                        | translate: { count: highlight.additionalMatches.length }
                    }}
                  </a>
                }
                @if (
                  highlight.additionalMatches.length > 0 &&
                  hasHighlightExtended(candidate.id, highlight.key)
                ) {
                  <span [innerHtml]="', ' + highlight.additionalMatches.join(', ')"> </span>
                  <a
                    (click)="
                      $event.stopPropagation(); toggleExtendHighlight(candidate.id, highlight.key)
                    "
                  >
                    {{ 'app.search.highlight.hide_additional_matches' | translate }}
                  </a>
                }
              </p>
            }
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #deletedBy let-row="row" [ngTemplateType]="CellContext">
  @if (row && row.deletedByGDPR) {
    <div layout layout-align-items-center>
      <rt-icon
        [name]="'gdpr-candidate'"
        colorToken="colorIconStrongDefault"
        margin-right-small
        class="gdpr-icon"
      ></rt-icon>
      <span text-weight-semi-bold> {{ 'app.search.table.deleted_by_gdpr' | translate }} </span>
    </div>
  }
  @if (row && !row.deletedByGDPR && row.deletedByAdmin; as admin) {
    <div layout layout-align-items-center>
      <rt-avatar
        [type]="admin.hasAvatar ? 'image' : 'initials'"
        [initials]="admin.initials"
        [size]="'small'"
        [shape]="'oval'"
        [imageSrc]="admin.photoThumbUrl"
        margin-right-small
        context="admin"
      >
      </rt-avatar>
      <span text-weight-semi-bold> {{ admin.firstName }} {{ admin.lastName }} </span>
    </div>
  }
</ng-template>

<ng-template #jobsList let-jobs let-candidate="row">
  @for (offer of jobs; track trackByEntityId(index, offer); let index = $index; let last = $last) {
    <div
      [attr.margin-bottom-small-xx]="
        (!last && candidate.locationPlaceholders[index].length > 1) || null
      "
      [class.restricted]="!hasAccessToOffer(offer.id)"
      class="job"
    >
      <div class="container" layout-centered-y>
        <rt-offer-status-indicator
          [offerStatus]="offer"
          margin-right-small-xx
        ></rt-offer-status-indicator>
        @if (hasAccessToOffer(offer.id)) {
          <a [routerLink]="['/offers', $any(offer).slug, 'pipeline']">
            <span white-space-no-wrap>
              {{ offer.title }}
            </span>
          </a>
        } @else {
          <span>
            <span white-space-no-wrap>
              {{ offer.title }}
            </span>
          </span>
        }
      </div>
      <ng-container
        [ngTemplateOutlet]="locationPlaceholders"
        [ngTemplateOutletContext]="{
          locationPlaceholders: candidate.locationPlaceholders[index],
        }"
      ></ng-container>
    </div>
  }
</ng-template>

<ng-template #jobs let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'jobs',
      all: candidate.allJobs,
      allLength: candidate.allJobs.length,
      short: candidate.jobs,
      shortLength: candidate.jobs.length,
      template: jobsList,
      expandLabel:
        'app.search.table.cell_expand.expand_jobs'
        | translate: { count: candidate.allJobs.length - candidate.jobs.length },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
      row: candidate,
    }"
  ></ng-container>
</ng-template>

<ng-template #talentPoolsList let-talentPools>
  @for (offer of talentPools; track trackByEntityId($index, offer)) {
    <div class="talent-pool">
      <rt-offer-status-indicator
        [offerStatus]="offer"
        margin-right-small-xx
      ></rt-offer-status-indicator>
      <span>
        {{ offer.title }}
      </span>
    </div>
  }
</ng-template>

<ng-template #talentPools let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'talent_pools',
      all: candidate.allTalentPools,
      allLength: candidate.allTalentPools.length,
      short: candidate.talentPools,
      shortLength: candidate.talentPools.length,
      template: talentPoolsList,
      expandLabel:
        'app.search.table.cell_expand.expand_talentpools'
        | translate: { count: candidate.allTalentPools.length - candidate.talentPools.length },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
    }"
  ></ng-container>
</ng-template>

<ng-template #stagesList let-stages let-candidate="row">
  @for (stage of stages; track trackByStage(index, stage); let index = $index; let last = $last) {
    <div
      [attr.margin-bottom-small-xx]="
        (!last && candidate.locationPlaceholders[index].length > 1) || null
      "
      [class.disqualified]="stage.disqualified"
      [class.has-overdue]="
        overdueCandidatesEnabled && !stage.disqualified && stage.overdueDiff! < 0
      "
      class="stage"
    >
      <div class="container" layout-centered-y>
        @if (stage.disqualified) {
          <rt-icon
            colorToken="colorIconCriticalDefault"
            size="small-x"
            name="block"
            margin-right-small-xx
          ></rt-icon>
        }
        @if (stage.hired && !stage.disqualified) {
          <rt-icon
            colorToken="colorIconSuccessDefault"
            size="small-x"
            name="hired"
            margin-right-small-xx
          ></rt-icon>
        }
        <span [rtTooltip]="!stage.disqualified ? stage.name : null" white-space-no-wrap>{{
          stage.name
        }}</span>
        @if (overdueCandidatesEnabled && !stage.disqualified && stage.overdueDiff! < 0) {
          <rt-overdue-candidate-badge
            [overdueDiff]="stage.overdueDiff!"
            [hasTooltip]="true"
          ></rt-overdue-candidate-badge>
        }
      </div>
      <ng-container
        [ngTemplateOutlet]="locationPlaceholders"
        [ngTemplateOutletContext]="{
          locationPlaceholders: candidate.locationPlaceholders[index],
        }"
      ></ng-container>
    </div>
  }
</ng-template>

<ng-template #stages let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'stages',
      all: candidate.allStages,
      allLength: candidate.allStages.length,
      short: candidate.stages,
      shortLength: candidate.stages.length,
      template: stagesList,
      expandLabel:
        'app.search.table.cell_expand.expand_stages'
        | translate: { count: candidate.allStages.length - candidate.stages.length },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
      row: candidate,
    }"
  ></ng-container>
</ng-template>

<ng-template #locationNamesList let-locationGroups let-candidate="row">
  @for (
    locationGroup of locationGroups;
    track trackByLocationGroup(index, locationGroup);
    let last = $last;
    let index = $index
  ) {
    <div
      [attr.padding-bottom-small-x]="
        (!last && candidate.locationPlaceholders[index].length > 1) || null
      "
      class="preferred-locations-group"
      padding-tb-small-xx
    >
      @for (
        placeholder of candidate.locationPlaceholders[index];
        track trackByLocation(placeholderIndex, placeholder);
        let placeholderIndex = $index;
        let firstPlaceholder = $first
      ) {
        @if (locationGroup[placeholderIndex]) {
          <span white-space-no-wrap>{{ locationGroup[placeholderIndex].name }}</span>
        }
        @if (!locationGroup[placeholderIndex]) {
          @if (!firstPlaceholder) {
            <div class="empty_div"></div>
          }
          @if (firstPlaceholder) {
            <ng-container [ngTemplateOutlet]="empty" />
          }
        }
      }

      @if (!candidate.locationPlaceholders[index].length) {
        <ng-container [ngTemplateOutlet]="empty" />
      }
    </div>
  }
</ng-template>

<ng-template #locationAddressList let-locationGroups let-candidate="row">
  @for (
    locationGroup of locationGroups;
    track trackByLocationGroup(index, locationGroup);
    let last = $last;
    let index = $index
  ) {
    <div
      [attr.padding-bottom-small-x]="
        (!last && candidate.locationPlaceholders[index].length > 1) || null
      "
      class="preferred-locations-group"
      padding-tb-small-xx
    >
      @for (
        placeholder of candidate.locationPlaceholders[index];
        track trackByLocation(placeholderIndex, placeholder);
        let placeholderIndex = $index;
        let firstPlaceholder = $first
      ) {
        @if (locationGroup[placeholderIndex]) {
          <span white-space-no-wrap>{{ locationGroup[placeholderIndex].fullAddress }}</span>
        }
        @if (!locationGroup[placeholderIndex]) {
          @if (!firstPlaceholder) {
            <div class="empty_div"></div>
          }
          @if (firstPlaceholder) {
            <ng-container [ngTemplateOutlet]="empty" />
          }
        }
      }

      @if (!candidate.locationPlaceholders[index].length) {
        <ng-container [ngTemplateOutlet]="empty" />
      }
    </div>
  }
</ng-template>

<ng-template #workLocations let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'work_location',
      all: candidate.allWorkLocations,
      allLength: candidate.allWorkLocations.length,
      short: candidate.workLocations,
      shortLength: candidate.workLocations.length,
      template: locationNamesList,
      expandLabel:
        'app.search.table.cell_expand.expand_work_locations_x'
        | translate: { count: candidate.hiddenWorkLocationsLength },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
      row: candidate,
    }"
  ></ng-container>
</ng-template>

<ng-template #jobLocationNames let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'job_location_name',
      all: candidate.allJobLocations,
      allLength: candidate.allJobLocations.length,
      short: candidate.jobLocations,
      shortLength: candidate.jobLocations.length,
      template: locationNamesList,
      expandLabel:
        'app.search.table.cell_expand.expand_job_locations_x'
        | translate: { count: candidate.hiddenJobLocationsLength },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
      row: candidate,
    }"
  ></ng-container>
</ng-template>

<ng-template #jobLocationAddress let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'job_location_address',
      all: candidate.allJobLocations,
      allLength: candidate.allJobLocations.length,
      short: candidate.jobLocations,
      shortLength: candidate.jobLocations.length,
      template: locationAddressList,
      expandLabel:
        'app.search.table.cell_expand.expand_job_locations_address_x'
        | translate: { count: candidate.hiddenJobLocationsLength },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
      row: candidate,
    }"
  ></ng-container>
</ng-template>

<ng-template #tags let-candidate="row" [ngTemplateType]="CellContext">
  @if (candidate.tags.length > 0) {
    <div class="tags">
      @for (tag of candidate.tags; track trackByEntityId($index, tag)) {
        <rt-tag [name]="tag.name" [isHoverable]="false" [isClickable]="false"> </rt-tag>
      }
    </div>
  }
  @if (candidate.tags.length === 0) {
    <ng-container [ngTemplateOutlet]="empty" />
  }
</ng-template>

<ng-template #sources let-candidate="row" [ngTemplateType]="CellContext">
  @if (candidate.sources.length > 0) {
    <div class="sources">
      @for (source of candidate.sources; track trackByEntityId($index, source)) {
        <rt-tag [name]="source.name" [isHoverable]="false" [isClickable]="false"> </rt-tag>
      }
    </div>
  }
  @if (candidate.sources.length === 0) {
    <ng-container [ngTemplateOutlet]="empty" />
  }
</ng-template>

<ng-template #createdAt let-candidate="row" [ngTemplateType]="CellContext">
  <rt-date [time]="candidate.createdAt" [tooltipPosition]="'left'"></rt-date>
</ng-template>

<ng-template #deletedAt let-candidate="row" [ngTemplateType]="CellContext">
  <rt-date [time]="candidate.softDeletedAt!" [tooltipPosition]="'left'"></rt-date>
</ng-template>

<ng-template #integrations let-candidate="row" [ngTemplateType]="CellContext">
  @if (elementsLoading(candidate)) {
    <rt-placeloader variant="item"></rt-placeloader>
  }

  @if (!elementsLoading(candidate)) {
    @if (elementsFor(candidate).length > 0) {
      <div class="elements">
        @for (element of elementsFor(candidate); track elementsTrackByFn($index, element)) {
          <rti-outlet
            [elements]="element"
            (click)="$event.stopPropagation()"
            class="badge"
          ></rti-outlet>
        }
      </div>
    }

    @if (elementsFor(candidate).length === 0) {
      <ng-container [ngTemplateOutlet]="empty" />
    }
  }
</ng-template>

<ng-template #lastActivity let-candidate="row" [ngTemplateType]="CellContext">
  <rt-date [time]="candidate.lastActivityAt!" [tooltipPosition]="'left'"></rt-date>
</ng-template>

<ng-template #disqualifyDate let-candidate="row" [ngTemplateType]="CellContext">
  @if (disqualifyDates[candidate.id]) {
    <rt-date [time]="disqualifyDates[candidate.id]" [tooltipPosition]="'left'"></rt-date>
  }
  @if (!disqualifyDates[candidate.id]) {
    <ng-container [ngTemplateOutlet]="empty" />
  }
</ng-template>

<ng-template #positiveRating let-candidate="row" [ngTemplateType]="CellContext">
  @if (candidate.ratingVisible) {
    @if (candidate.positiveRatings || candidate.positiveRatings === 0) {
      <div layout-horizontal layout-align-items-center>
        <rt-interview-evaluation-rating
          [size]="'small'"
          [rating]="candidate.positiveRatings"
        ></rt-interview-evaluation-rating>
        <span text-weight-semi-bold>{{ candidate.positiveRatings }}%</span>
      </div>
    } @else {
      <ng-container [ngTemplateOutlet]="empty" />
    }
  } @else {
    <div
      [rtTooltip]="'app.candidate.placements.hidden_job_fit_score' | translate"
      [rtTooltipHideDelay]="0"
      class="hidden-score"
      layout-centered-y
    >
      <rt-hidden-score-icon color="light" size="small" height="30px"></rt-hidden-score-icon>
    </div>
  }
</ng-template>

<ng-template #jobFitScore let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'jobs',
      all: candidate.allJobPlacements,
      allLength: candidate.allJobPlacements.length,
      short: candidate.jobPlacements,
      shortLength: candidate.jobPlacements.length,
      template: jobFitScoreList,
      expandLabel:
        'app.search.table.cell_expand.expand_job_fit_score'
        | translate: { count: candidate.allJobPlacements.length - candidate.jobPlacements.length },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
      row: candidate,
    }"
  ></ng-container>
</ng-template>

<ng-template #jobFitScoreList let-jobPlacements let-candidate="row">
  @for (
    placement of jobPlacements;
    track trackByEntityId(index, placement);
    let index = $index;
    let last = $last
  ) {
    <div
      [attr.margin-bottom-small-xx]="
        (!last && candidate.locationPlaceholders[index].length > 1) || null
      "
      class="job-fit-score"
    >
      @if (placement.offer?.kind === OfferKind.Job) {
        <div class="container" layout-centered-y>
          @if (placement.ratingVisible) {
            @if (placement.positiveRatings || placement.positiveRatings === 0) {
              <div layout-horizontal layout-align-items-center>
                <rt-interview-evaluation-rating
                  [size]="'small'"
                  [rating]="placement.positiveRatings"
                ></rt-interview-evaluation-rating>
                <span>{{ placement.positiveRatings }}%</span>
              </div>
            } @else {
              <ng-container [ngTemplateOutlet]="empty" />
            }
          } @else {
            <div
              [rtTooltip]="'app.candidate.placements.hidden_job_fit_score' | translate"
              [rtTooltipHideDelay]="0"
              class="hidden-score"
              layout-centered-y
            >
              <rt-hidden-score-icon color="light" size="small" height="30px"></rt-hidden-score-icon>
            </div>
          }
        </div>
      }
      <ng-container
        [ngTemplateOutlet]="locationPlaceholders"
        [ngTemplateOutletContext]="{
          locationPlaceholders: candidate.locationPlaceholders[index],
        }"
      ></ng-container>
    </div>
  }
</ng-template>

<ng-template #hiredAt let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'hired_at',
      all: candidate.allJobPlacements,
      allLength: candidate.allJobPlacements.length,
      short: candidate.jobPlacements,
      shortLength: candidate.jobPlacements.length,
      template: hiredAtList,
      expandLabel:
        'app.search.table.cell_expand.expand_hired_at'
        | translate: { count: candidate.allJobPlacements.length - candidate.jobPlacements.length },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
      row: candidate,
    }"
  ></ng-container>
</ng-template>

<ng-template #hiredAtList let-jobPlacements let-candidate="row">
  @for (
    placement of jobPlacements;
    track trackByEntityId(index, placement);
    let index = $index;
    let last = $last
  ) {
    <div
      [attr.margin-bottom-small-xx]="
        (!last && candidate.locationPlaceholders[index].length > 1) || null
      "
      class="hired-at"
    >
      @if (placement.offer?.kind === OfferKind.Job) {
        <div class="container" layout-centered-y>
          @if (
            placement.hiredAt?.length &&
            (timeService.isBeforeToday(placement.hiredAt) || timeService.isToday(placement.hiredAt))
          ) {
            @if (timeService.isToday(placement.hiredAt)) {
              <span [rtTooltip]="placement.hiredAt | amDateFormat: 'll'">
                {{ 'app.common.today' | translate | titlecase }}
              </span>
            }
            @if (timeService.isBeforeToday(placement.hiredAt)) {
              <rt-date [time]="placement.hiredAt" amDateFormatPattern="ll"></rt-date>
            }
          } @else {
            <ng-container [ngTemplateOutlet]="empty" />
          }
        </div>
        <ng-container
          [ngTemplateOutlet]="locationPlaceholders"
          [ngTemplateOutletContext]="{
            locationPlaceholders: candidate.locationPlaceholders[index],
          }"
        ></ng-container>
      }
    </div>
  }
</ng-template>

<ng-template #jobStartsAt let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'job_starts_at',
      all: candidate.allJobPlacements,
      allLength: candidate.allJobPlacements.length,
      short: candidate.jobPlacements,
      shortLength: candidate.jobPlacements.length,
      template: jobStartsAtList,
      expandLabel:
        'app.search.table.cell_expand.expand_job_starts_at'
        | translate: { count: candidate.allJobPlacements.length - candidate.jobPlacements.length },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
      row: candidate,
    }"
  ></ng-container>
</ng-template>

<ng-template #jobStartsAtList let-jobPlacements let-candidate="row">
  @for (
    placement of jobPlacements;
    track trackByEntityId(index, placement);
    let index = $index;
    let last = $last
  ) {
    <div
      [attr.margin-bottom-small-xx]="
        (!last && candidate.locationPlaceholders[index].length > 1) || null
      "
      class="job-starts-at"
    >
      @if (placement.offer?.kind === OfferKind.Job) {
        <div class="container" layout-centered-y>
          @if (placement.jobStartsAt?.length) {
            @if (timeService.isTomorrow(placement.jobStartsAt)) {
              <span [rtTooltip]="placement.jobStartsAt | amDateFormat: 'll'">
                {{ 'app.common.tomorrow' | translate }}
              </span>
            }
            @if (
              timeService.isAfterToday(placement.jobStartsAt) &&
              !timeService.isTomorrow(placement.jobStartsAt)
            ) {
              <span [rtTooltip]="placement.jobStartsAt | amDateFormat: 'll'" white-space-no-wrap>
                {{
                  'app.search.table.days_left'
                    | translate: { count: placement.jobStartsAt | rtDaysLeft: { round: true } }
                }}
              </span>
            }
            @if (timeService.isToday(placement.jobStartsAt)) {
              <span [rtTooltip]="placement.jobStartsAt | amDateFormat: 'll'">
                {{ 'app.common.today' | translate | titlecase }}
              </span>
            }
            @if (timeService.isBeforeToday(placement.jobStartsAt)) {
              <rt-date [time]="placement.jobStartsAt" amDateFormatPattern="ll"></rt-date>
            }
          } @else {
            <ng-container [ngTemplateOutlet]="empty" />
          }
        </div>
        <ng-container
          [ngTemplateOutlet]="locationPlaceholders"
          [ngTemplateOutletContext]="{
            locationPlaceholders: candidate.locationPlaceholders[index],
          }"
        ></ng-container>
      }
    </div>
  }
</ng-template>

<ng-template #gdprExpiresAt let-candidate="row" [ngTemplateType]="CellContext">
  @if (candidate.gdprExpiresAt) {
    @if (!isExpired(candidate.gdprExpiresAt)) {
      <span
        [class.color-critical]="isExpiring(candidate.gdprExpiresAt)"
        [rtTooltip]="candidate.gdprExpiresAt | amDateFormat: 'lll'"
        [rtTooltipPosition]="'above'"
      >
        {{
          'app.search.table.days_left'
            | translate: { count: candidate.gdprExpiresAt | rtDaysLeft: { round: true } }
        }}
      </span>
    }
    @if (isExpired(candidate.gdprExpiresAt)) {
      <rt-date
        [time]="candidate.gdprExpiresAt"
        [tooltipPosition]="'above'"
        variant="default color-red"
      >
      </rt-date>
    }
  }
  @if (!candidate.gdprExpiresAt) {
    <ng-container [ngTemplateOutlet]="empty" />
  }
</ng-template>

<ng-template #gdprStatus let-candidate="row" [ngTemplateType]="CellContext">
  @if (candidate.gdprStatus) {
    <span
      [rtTooltip]="'app.search.table.gdpr_status_tooltip.' + candidate.gdprStatus | translate"
      [class.color-critical]="
        isExpiring(candidate.gdprExpiresAt) && !isGdprStatusNoConsent(candidate.gdprStatus)
      "
      [class.color-orange]="isGdprStatusNoConsent(candidate.gdprStatus)"
      >{{ 'app.gdpr.status_badge.' + candidate.gdprStatus + '.label' | translate }}</span
    >
  }
</ng-template>

<ng-template #eeoStatus let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'jobs',
      all: candidate.allJobPlacements,
      allLength: candidate.allJobPlacements.length,
      short: candidate.jobPlacements,
      shortLength: candidate.jobPlacements.length,
      template: eeoStatusList,
      expandLabel:
        'app.search.table.cell_expand.expand_eeo_status'
        | translate: { count: candidate.allJobPlacements.length - candidate.jobPlacements.length },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
      row: candidate,
    }"
  ></ng-container>
</ng-template>

<ng-template #eeoStatusList let-jobPlacements let-candidate="row">
  @for (
    placement of jobPlacements;
    track trackByEntityId(index, placement);
    let last = $last;
    let index = $index
  ) {
    <div
      [attr.margin-bottom-small-xx]="
        (!last && candidate.locationPlaceholders[index].length > 1) || null
      "
      class="eeo"
    >
      @if (placement.eeoDataStatus) {
        <div class="container" layout-centered-y>
          @switch (placement.eeoDataStatus) {
            @case (EEODataStatus.NoEEOData) {
              <span
                [rtTooltip]="'app.eeoc.status.no_data_tooltip' | translate"
                [rtTooltipHasTextAlignCenter]="true"
                [rtTooltipMaxWidth]="170"
                class="color-red"
                ><rt-truncate>{{ 'app.eeoc.status.no_data' | translate }}</rt-truncate>
              </span>
            }
            @case (EEODataStatus.Requested) {
              <span
                [rtTooltip]="'app.eeoc.status.requested_tooltip' | translate"
                [rtTooltipHasTextAlignCenter]="true"
                [rtTooltipMaxWidth]="170"
                white-space-no-wrap
                >{{ 'app.eeoc.status.requested' | translate }}
              </span>
            }
            @case (EEODataStatus.Completed) {
              <span
                [rtTooltip]="'app.eeoc.status.completed_tooltip' | translate"
                [rtTooltipHasTextAlignCenter]="true"
                [rtTooltipMaxWidth]="170"
                white-space-no-wrap
                >{{ 'app.eeoc.status.completed' | translate }}
              </span>
            }
          }
        </div>
      }
      @if (!placement.eeoDataStatus) {
        <ng-container [ngTemplateOutlet]="empty" />
      }
      <ng-container
        [ngTemplateOutlet]="locationPlaceholders"
        [ngTemplateOutletContext]="{
          locationPlaceholders: candidate.locationPlaceholders[index],
        }"
      ></ng-container>
    </div>
  }
</ng-template>

<ng-template #disqualifiedBy let-candidate="row" [ngTemplateType]="CellContext">
  <ng-container
    [ngTemplateOutlet]="expandable"
    [ngTemplateOutletContext]="{
      group: 'placements',
      id: candidate.id,
      columnId: 'jobs',
      all: candidate.allJobPlacements,
      allLength: candidate.allJobPlacements.length,
      short: candidate.jobPlacements,
      shortLength: candidate.jobPlacements.length,
      template: disqualifiedByList,
      expandLabel:
        'app.search.table.cell_expand.expand_disqualified_by'
        | translate: { count: candidate.allJobPlacements.length - candidate.jobPlacements.length },
      collapseLabel: 'app.search.table.cell_expand.hide' | translate,
      row: candidate,
    }"
  ></ng-container>
</ng-template>
<ng-template #disqualifiedByList let-jobPlacements let-candidate="row">
  @for (
    placement of jobPlacements;
    track trackByEntityId(index, placement);
    let index = $index;
    let last = $last
  ) {
    <div
      [attr.margin-bottom-small-xx]="
        (!last && candidate.locationPlaceholders[index].length > 1) || null
      "
      class="disqualified-by"
    >
      <div class="container" layout-centered-y>
        @if (placement.disqualified) {
          <span>
            {{ getDisqualifiedByLabel(placement) }}
          </span>
        } @else {
          <ng-container [ngTemplateOutlet]="empty" />
        }
      </div>
      <ng-container
        [ngTemplateOutlet]="locationPlaceholders"
        [ngTemplateOutletContext]="{
          locationPlaceholders: candidate.locationPlaceholders[index],
        }"
      ></ng-container>
    </div>
  }
</ng-template>

<ng-template #empty>
  <rt-truncate>
    <span class="empty">—</span>
  </rt-truncate>
</ng-template>

<ng-template
  #gdprUncompletedChangeRequestCreatedAt
  let-candidate="row"
  [ngTemplateType]="CellContext"
>
  <rt-date [time]="candidate.gdprUncompletedChangeRequestCreatedAt" [tooltipPosition]="'left'">
  </rt-date>
</ng-template>

<ng-template
  #gdprUncompletedRemovalRequestCreatedAt
  let-candidate="row"
  [ngTemplateType]="CellContext"
>
  <rt-date [time]="candidate.gdprUncompletedRemovalRequestCreatedAt" [tooltipPosition]="'left'">
  </rt-date>
</ng-template>

<ng-template #placeloaderCell [ngTemplateType]="CellContext">
  <rt-placeloader variant="item"></rt-placeloader>
</ng-template>
<ng-template #columnHeaderTpl [ngTemplateType]="HeaderContext" let-column="col">
  <div [innerHTML]="column.label"></div>
</ng-template>

@if (!loaded) {
  <rt-data-table
    [raised]="true"
    [rows]="placeloaderRows"
    [cols]="dtColumns"
    [autoFit]="autoFit"
    [defaultCellTemplate]="placeloaderCell"
    [columnHeaderTemplate]="columnHeaderTpl"
    [clickable]="true"
    [selectable]="selectable"
    (sortChange)="handleSortChange($event)"
    (geometryChange)="handleGeometryChange($event)"
  >
  </rt-data-table>
}

@if (loaded) {
  <rt-data-table
    [raised]="true"
    [rows]="rows"
    [cols]="dtColumns"
    [autoFit]="autoFit"
    [cellTemplates]="cellTemplates[view]"
    [columnHeaderTemplate]="columnHeaderTpl"
    [clickable]="true"
    [selectable]="selectable"
    [selectedIdsDict]="selectedIdsDict"
    (rowClick)="handleRowClick($event)"
    (rowSelect)="handleRowSelect($event)"
    (sortChange)="handleSortChange($event)"
    (geometryChange)="handleGeometryChange($event)"
  >
  </rt-data-table>
}
